function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useMemo } from 'react';
import { isArray, isBoolean, isNullOrUndefined, isNumber, isString } from '@okee-uikit/react-utils';
import { useDirection } from '../context/direction';
import { useConfig } from './useConfig';
var HYPHEN = '-';
var DOUBLE_HYPHEN = '--';
var UNDERSCORE = '_';
var DOUBLE_UNDERSCORE = '__';
var sepPrefixMain = HYPHEN;
var sepCompElem = HYPHEN;
var sepMainSuffix = UNDERSCORE;
var sepKeyValue = UNDERSCORE;

var concatCompElem = function concatCompElem(comp, elem) {
  return "".concat(comp).concat(sepCompElem).concat(elem);
};

function normalize(prefix, main, suffixMap, extras) {
  var core = "".concat(prefix).concat(sepPrefixMain).concat(main);
  var classNames = [core];
  var suffixEntries = suffixMap && Object.entries(suffixMap) || [];
  var length = suffixEntries.length;

  for (var i = 0; i < length; i++) {
    var _suffixEntries$i = _slicedToArray(suffixEntries[i], 2),
        key = _suffixEntries$i[0],
        value = _suffixEntries$i[1];

    if (isNullOrUndefined(value)) {
      continue;
    }

    if (isBoolean(value)) {
      if (value) {
        classNames.push("".concat(core).concat(sepMainSuffix).concat(key));
      }

      continue;
    }

    if (isBoolean(value)) {
      if (value) {
        classNames.push("".concat(core).concat(sepMainSuffix).concat(key));
      }

      continue;
    }

    if (isString(value) || isNumber(value)) {
      classNames.push("".concat(core).concat(sepMainSuffix).concat(key).concat(sepKeyValue).concat(value));
    }
  }

  if (isArray(extras)) {
    var _length = extras.length;

    for (var _i2 = 0; _i2 < _length; _i2++) {
      var item = extras[_i2];

      if (item) {
        classNames.push(item);
      }
    }
  }

  return classNames.join(' ');
}

function createCEP(componentName, options) {
  var _options$prefix = options.prefix,
      prefix = _options$prefix === void 0 ? 'c' : _options$prefix,
      injectedProps = options.injectedProps;

  var comp = function comp(props) {
    for (var _len = arguments.length, extras = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      extras[_key - 1] = arguments[_key];
    }

    return normalize(prefix, componentName, _objectSpread(_objectSpread({}, props), injectedProps), extras);
  };

  var elem = function elem(elementName, stats) {
    for (var _len2 = arguments.length, extras = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      extras[_key2 - 2] = arguments[_key2];
    }

    return normalize(prefix, concatCompElem(componentName, elementName), stats, extras);
  };

  return {
    comp: comp,
    elem: elem
  };
}

export function useCEP(componentName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$injectDirect = options.injectDirection,
      injectDirection = _options$injectDirect === void 0 ? true : _options$injectDirect;

  var _useConfig = useConfig(),
      prefixCls = _useConfig.prefixCls;

  var direction = useDirection();
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, createCEP(componentName, {
      prefix: prefixCls,
      injectedProps: {
        rtl: injectDirection && direction === 'rtl'
      }
    })), {}, {
      direction: direction
    });
  }, [direction, prefixCls, componentName]);
}